import { DateTime } from "../../../../components/Common/CommonFunction";

export const fmtINR = (v) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(v);

export const fmtNum = (v) => new Intl.NumberFormat("en-IN").format(v);

export const fmtLogDate = (v) => {
  if (!v) return "";
  const d = new Date(v);
  return isNaN(d.getTime()) ? "" : DateTime(v);
};

export const normalizeApiData = (response) => {
  if (!response) return [];
  const source = response.Data || response.data || response;
  if (Array.isArray(source)) return source;
  if (source && typeof source === "object") return Object.values(source);
  return [];
};
